import { render, staticRenderFns } from "./StatesInfo.vue?vue&type=template&id=f1daa4d2"
import script from "./StatesInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatesInfo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports